function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import morphdom from 'morphdom';

// Shamelessly stolen from Turbo. Makes the submit event listenable from Safari.
// https://github.com/hotwired/turbo/blob/main/src/polyfills/submit-event.ts
var submittersByForm = new WeakMap();
function findSubmitterFromClickTarget(target) {
  var element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
  var candidate = element != null ? element.closest('input, button') : null;
  if (candidate != null && candidate.type === 'submit') {
    return candidate;
  }
  return null;
}
function clickCaptured(event) {
  var submitter = findSubmitterFromClickTarget(event.target);
  if ((submitter === null || submitter === void 0 ? void 0 : submitter.form) != null) {
    submittersByForm.set(submitter.form, submitter);
  }
}
(function () {
  var prototype = Event.prototype;
  // Safari 15 has a bug with submitters, this is a check for that.
  var isSafari = navigator.vendor.includes('Apple Computer');
  if ('SubmitEvent' in window) {
    // No need to continue, polyfill not needed. Safari 15 has a bug with submitters.
    if (!isSafari) return;
    // We have to attach to the SubmitEvent prototype in Safari instead of Event prototype.
    prototype = window.SubmitEvent.prototype;
  }
  // Polyfill has already been run, do not pass go.
  if ('submitter' in prototype) return;
  addEventListener('click', clickCaptured, true);
  Object.defineProperty(prototype, 'submitter', {
    get: function get() {
      if (this.type === 'submit' && this.target instanceof HTMLFormElement) {
        return submittersByForm.get(this.target);
      }
      return undefined;
    }
  });
})();
var _a;
function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  } else if (Array.from != null) {
    return Array.from(value);
  } else {
    return [].slice.call(value);
  }
}
var m = (_a = Element.prototype.matches) !== null && _a !== void 0 ? _a : Element.prototype.webkitMatchesSelector;
/**
 * Checks if the given native dom element matches the selector
 * @example
 *   matches(document.querySelector("form"), { selector: "form", exclude: "form[data-remote='true']"})
 *   matches(document.querySelector("form"), "form")
 */
function matches$1(element, selector) {
  if (!(element instanceof Element)) {
    return false;
  }
  if (typeof selector === 'string') {
    return m.call(element, selector);
  }
  return m.call(element, selector.selector) && !m.call(element, selector.exclude);
}
var form = 'form';
var link = 'a';
if (window.Turbo != null) {
  form = 'form[data-turbo="false"]';
  link = 'a[data-turbo="false"]';
}
var data = 'data-';
var remote = "".concat(data, "remote");
var method = "".concat(data, "method");
var confirm$2 = "".concat(data, "confirm");
var disable = "".concat(data, "disable");
var disableWith = "".concat(disable, "-with");
var BASE_SELECTORS = {
  remoteSelector: "a[".concat(remote, "=\"true\"], a[").concat(method, "], form[").concat(remote, "=\"true\"]"),
  // Link elements bound by rails-ujs
  linkClickSelector: "a[".concat(confirm$2, "], ").concat(link, "[").concat(method, "], ").concat(link, "[").concat(remote, "]:not([disabled]), ").concat(link, "[").concat(disableWith, "], ").concat(link, "[").concat(disable, "]"),
  // Button elements bound by rails-ujs
  buttonClickSelector: {
    selector: "button[".concat(remote, "]:not([form]), button[").concat(confirm$2, "]:not([form]), button[").concat(disableWith, "]:not([form]), button[").concat(disable, "]:not([form])"),
    exclude: 'form button'
  },
  // Select elements bound by rails-ujs
  inputChangeSelector: "select[".concat(remote, "], input[").concat(remote, "], textarea[").concat(remote, "]"),
  // Form elements bound by rails-ujs
  formSubmitSelector: "".concat(form),
  // Form input elements bound by rails-ujs
  formInputClickSelector: 'form input[type=submit], form input[type=image], form button[type=submit], form button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])',
  // Form input elements disabled during form submission
  formDisableSelector: "input[".concat(disableWith, "]:enabled, button[").concat(disableWith, "]:enabled, textarea[").concat(disableWith, "]:enabled, input[").concat(disable, "]:enabled, button[").concat(disable, "]:enabled, textarea[").concat(disable, "]:enabled"),
  // Form input elements re-enabled after form submission
  formEnableSelector: "input[".concat(disableWith, "]:disabled, button[").concat(disableWith, "]:disabled, textarea[").concat(disableWith, "]:disabled, input[").concat(disable, "]:disabled, button[").concat(disable, "]:disabled, textarea[").concat(disable, "]:disabled"),
  // Link onClick disable selector with possible reenable after remote submission
  linkDisableSelector: "a[".concat(disableWith, "], a[").concat(disable, "]"),
  // Button onClick disable selector with possible reenable after remote submission
  buttonDisableSelector: "button[data-remote][".concat(disableWith, "], button[data-remote][").concat(disable, "]"),
  fileInputSelector: 'fileInputSelector: \'input[name][type=file]:not([disabled])\''
};
function addListeners(conditions, callbacks) {
  conditions.forEach(function (condition) {
    var selectors = condition.selectors,
      event = condition.event;
    var selectorString = selectors.map(selectorToString).join(', ');
    $$1(selectorString).forEach(function (el) {
      selectors.forEach(function (selector) {
        if (matches$1(el, selector)) {
          callbacks.forEach(function (callback) {
            return el.addEventListener(event, callback);
          });
        }
      });
    });
  });
}
function removeListeners(conditions, callbacks) {
  conditions.forEach(function (condition) {
    var selectors = condition.selectors,
      event = condition.event;
    var selectorString = selectors.map(selectorToString).join(', ');
    $$1(selectorString).forEach(function (el) {
      selectors.forEach(function (selector) {
        if (matches$1(el, selector)) {
          callbacks.forEach(function (callback) {
            return el.removeEventListener(event, callback);
          });
        }
      });
    });
  });
}
function attachObserverCallback(conditions, nodeList, callbacks) {
  conditions.forEach(function (condition) {
    condition.selectors.forEach(function (selector) {
      nodeList.forEach(function (node) {
        if (matches$1(node, selector)) {
          callbacks.forEach(function (cb) {
            return node.addEventListener(condition.event, cb);
          });
        }
        if (node instanceof Element) {
          node.querySelectorAll(selectorToString(selector)).forEach(function (el) {
            callbacks.forEach(function (cb) {
              return el.addEventListener(condition.event, cb);
            });
          });
        }
      });
    });
  });
}
/**
 * Helper function that returns form elements that match the specified CSS selector
 *   If form is actually a "form" element this will return associated elements outside the from that have
 *   the html form attribute set
 */
function formElements$1(form, selector) {
  if (matches$1(form, 'form')) {
    return Array.from(form.elements).filter(function (el) {
      return matches$1(el, selector);
    });
  }
  return toArray(form.querySelectorAll(selectorToString(selector)));
}
function $$1(selector) {
  return toArray(document.querySelectorAll(selector));
}
function selectorToString(selector) {
  var str;
  if (typeof selector === 'string') {
    str = selector;
  } else {
    str = selector.selector;
  }
  return str;
}
var EVENT_DEFAULTS = {
  bubbles: true,
  cancelable: true
};
/**
 * Thin wrapper around element.dispatchEvent and new CustomEvent
 */
function dispatch(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var event = new CustomEvent(name, _objectSpread(_objectSpread({}, EVENT_DEFAULTS), options));
  this.dispatchEvent(event);
  return event;
}
/**
 * Backwards compatibility function that hooks into dispatch.
 */
function fire$1(element, name) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var event = dispatch.call(element, name, options);
  return !event.defaultPrevented;
}
function stopEverything$1(event) {
  if (event.target != null) fire$1(event.target, 'ujs:everythingStopped');
  event.stopPropagation();
  event.stopImmediatePropagation();
  event.preventDefault();
}
var prefix = 'ajax';
var AJAX_EVENTS = {
  /**
   * Before the ajax event gets sent.
   * You can view what data will be sent via: `event.detail.formData`
   */
  ajaxBefore: "".concat(prefix, ":before"),
  /**
   * Just prior to sending the fetch request
   */
  ajaxBeforeSend: "".concat(prefix, ":beforeSend"),
  /**
   * When the fetch request is sent. You can view whats being sent via:
   * `event.detail.formData`
   */
  ajaxSend: "".concat(prefix, ":send"),
  /**
   * When a response error occurs. IE: 400, 404, 422, 500, etc (any status code not between 200 - 299)
   * The response error can be viewed via: `event.detail.response`
   */
  ajaxResponseError: "".concat(prefix, ":response:error"),
  /**
   * Catches errors with requests such as Network errors.
   */
  ajaxRequestError: "".concat(prefix, ":request:error"),
  /**
   * When a >= 200 and <= 299 response is returned
   * You can view the full response via: `event.detail.response`
   */
  ajaxSuccess: "".concat(prefix, ":success"),
  /**
   * A unified event to catch both Response and Request errors.
   * You can view the error via: `event.detail.error`
   * This will also generate an error in your console.log
   */
  ajaxError: "".concat(prefix, ":error"),
  /**
   * After any fetch request, regardless of outcome
   * Does not have any accessible data besides the event itself
   */
  ajaxComplete: "".concat(prefix, ":complete"),
  ajaxStopped: "".concat(prefix, ":stopped"),
  ajaxBeforeNavigation: "".concat(prefix, ":beforeNavigation")
  // NOT CURRENTLY IMPLEMENTED
  // /**
  //  * when there are blank required fields in a form, submits anyway if stopped
  //  */
  // ajaxAbortedRequired: `${prefix}:aborted:required`,
  // /**
  //  * if there are non-blank input:file fields in a form, aborts if stopped
  //  */
  // ajaxAbortedFile: `${prefix}:aborted:file`
};
/**
 * Delegates events
 * to a specified parent `element`, which fires event `handler`
 * for the specified `selector` when an event of `eventType` is triggered
 * element::
 *   parent element that will listen for events e.g. document
 * selector::
 *   css selector; or an object that has `selector` and `exclude` properties (see: Rails.matches)
 * eventType::
 *   string representing the event e.g. 'submit', 'click'
 * handler::
 *   the event handler to be called
 */
function delegate$1(element, selector, eventType, handler) {
  element.addEventListener(eventType, function (event) {
    var target = event.target;
    while (!(!(target instanceof Element) || matches$1(target, selector))) {
      target = target.parentNode;
    }
    if (target instanceof Element && handler.call(target, event) === false) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}
function findSubmitter(event) {
  var _a;
  // Not supported by webkit
  if (event.submitter instanceof HTMLElement) {
    return event.submitter;
  }
  // we have a polyfill that adds submitter on event.detail
  return (_a = event.detail) === null || _a === void 0 ? void 0 : _a.submitter;
}
function expandUrl(locateable) {
  return new URL(locateable.toString(), document.baseURI);
}
function urlsAreEqual(left, right) {
  return expandUrl(left).href === expandUrl(right).href;
}
function mergeHeaders() {
  var main = {};
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];
    var _iterator = _createForOfIteratorHelper(source),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref = _step.value;
        var _ref2 = _slicedToArray(_ref, 2);
        var header = _ref2[0];
        var value = _ref2[1];
        main[header] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return new Headers(main);
}
function isGetRequest(method) {
  return method.toLowerCase() === 'get';
}

// Shamelessly stolen from Turbo.
// https://github.com/hotwired/turbo/blob/main/src/http/fetch_response.ts
function FetchResponse$1(response) {
  var _text;
  var _json;
  var succeeded = response.ok;
  var status = response.status;
  var failed = !succeeded;
  var clientError = response.status >= 400 && response.status <= 499;
  var serverError = response.status >= 500 && response.status <= 599;
  var redirected = response.redirected;
  var location = expandUrl(response.url);
  var contentType = getHeader('content-type');
  var isHtml = Boolean(contentType === null || contentType === void 0 ? void 0 : contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/));
  var isJson = Boolean(contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase().match(/(^application\/json|\.json)/));
  function text() {
    return _text2.apply(this, arguments);
  }
  function _text2() {
    _text2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_text != null)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", _text);
          case 2:
            _context.next = 4;
            return response.clone().text();
          case 4:
            _text = _context.sent;
            return _context.abrupt("return", _text);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _text2.apply(this, arguments);
  }
  function html() {
    return _html.apply(this, arguments);
  }
  function _html() {
    _html = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isHtml) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return text();
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 4:
            _context2.next = 6;
            return Promise.reject(response);
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _html.apply(this, arguments);
  }
  function json() {
    return _json2.apply(this, arguments);
  }
  function _json2() {
    _json2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!isJson) {
              _context3.next = 9;
              break;
            }
            if (!(_json != null)) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", _json);
          case 3:
            _context3.t0 = JSON;
            _context3.next = 6;
            return text();
          case 6:
            _context3.t1 = _context3.sent;
            _json = _context3.t0.parse.call(_context3.t0, _context3.t1);
            return _context3.abrupt("return", _json);
          case 9:
            _context3.next = 11;
            return Promise.reject(response);
          case 11:
            return _context3.abrupt("return", _context3.sent);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _json2.apply(this, arguments);
  }
  function getHeader(name) {
    return response.headers.get(name);
  }
  return {
    succeeded: succeeded,
    failed: failed,
    redirected: redirected,
    clientError: clientError,
    serverError: serverError,
    location: location,
    contentType: contentType,
    getHeader: getHeader,
    isHtml: isHtml,
    isJson: isJson,
    text: text,
    html: html,
    json: json,
    response: response,
    status: status
  };
}
function buildFormElementFormData(element, submitter) {
  var formData = new FormData(element);
  var name;
  var value;
  if (submitter != null) {
    name = submitter.getAttribute('name');
    value = submitter.getAttribute('value');
  }
  if (name != null && value != null && formData.get(name) !== value) {
    formData.append(name, value);
  }
  return formData;
}
var FormEncTypes = {
  urlEncoded: 'application/x-www-form-urlencoded',
  multipart: 'multipart/form-data',
  plain: 'text/plain'
};
function formEnctypeFromString(encoding) {
  switch (encoding.toLowerCase()) {
    case FormEncTypes.multipart:
      return FormEncTypes.multipart;
    case FormEncTypes.plain:
      return FormEncTypes.plain;
    default:
      return FormEncTypes.urlEncoded;
  }
}
function formDataToStrings(formData) {
  return _toConsumableArray(formData).reduce(function (entries, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      name = _ref4[0],
      value = _ref4[1];
    return entries.concat(typeof value === 'string' ? [[name, value]] : []);
  }, []);
}
function urlEncodeFormData(formData) {
  return new URLSearchParams(formDataToStrings(formData));
}
var BASE_ACCEPT_HEADERS = {
  '*': '*/*',
  any: '*/*',
  text: 'text/plain',
  html: 'text/html',
  xml: 'application/xml, text/xml',
  json: 'application/json, text/javascript',
  script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'
};
function findResponseTypeHeader(responseType) {
  var _a, _b, _c;
  var mimeTypes = (_b = (_a = window.mrujs) === null || _a === void 0 ? void 0 : _a.mimeTypes) !== null && _b !== void 0 ? _b : BASE_ACCEPT_HEADERS;
  var acceptHeaders = _objectSpread({}, mimeTypes);
  if (responseType == null) {
    return (_c = acceptHeaders === null || acceptHeaders === void 0 ? void 0 : acceptHeaders.any) !== null && _c !== void 0 ? _c : '*/*';
  }
  responseType = responseType.trim();
  if (acceptHeaders != null && Object.keys(acceptHeaders).includes(responseType)) {
    responseType = acceptHeaders[responseType];
  }
  if (responseType.includes('*/*')) return responseType;
  return "".concat(responseType, ", */*; q=0.01");
}

/**
 * Any click that we shouldn't handle.
 */
function isInsignificantClick(event) {
  return event.target != null && event.target.isContentEditable || event.defaultPrevented || event.button > 0 ||
  // Only left clicks!
  event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}
function preventInsignificantClick$1(event) {
  var _a, _b, _c, _d;
  // eslint-disable-next-line
  var method = (((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, 'data-method')) || ((_d = (_c = event.target) === null || _c === void 0 ? void 0 : _c.form) === null || _d === void 0 ? void 0 : _d.method) || 'get').toLowerCase();
  // Always let "get" pass through. They should be "idempotent"
  if (method === 'get') {
    return;
  }
  if (isInsignificantClick(event)) {
    stopEverything$1(event);
  }
}
function getCookieValue(cookieName) {
  if (cookieName != null) {
    var cookies = document.cookie.trim() !== '' ? document.cookie.split('; ') : [];
    var cookie = cookies.find(function (cookie) {
      return cookie.startsWith(cookieName);
    });
    if (cookie != null) {
      var value = cookie.split('=').slice(1).join('=');
      return value.trim() !== '' ? decodeURIComponent(value) : undefined;
    }
  }
  return undefined;
}
function getMetaContent(str) {
  var _a;
  var elements = $$1("meta[name=\"".concat(str, "\"]"));
  var element = elements[elements.length - 1];
  return (_a = element === null || element === void 0 ? void 0 : element.content) !== null && _a !== void 0 ? _a : undefined;
}

// https://github.com/rails/rails/blob/main/actionview/app/assets/javascripts/rails-ujs/utils/csrf.coffee
function Csrf() {
  return {
    name: 'Csrf',
    connect: connect$3,
    disconnect: disconnect$3,
    observerCallback: observerCallback
  };
}
function connect$3() {
  refreshCSRFTokens$1();
}
function disconnect$3() {}
function observerCallback(nodeList) {
  for (var i = 0; i < nodeList.length; i++) {
    var node = nodeList[i];
    if (isCsrfToken(node)) {
      refreshCSRFTokens$1();
    }
  }
}
// Make sure that all forms have actual up-to-date tokens (cached forms contain old ones)
function refreshCSRFTokens$1() {
  var token = csrfToken$1();
  var param = csrfParam$1();
  if (token != null && param != null) {
    $$1("form input[name=\"".concat(param, "\"]")).forEach(function (input) {
      var inputEl = input;
      inputEl.value = token;
    });
  }
}
function isCsrfToken(node) {
  if (node instanceof HTMLMetaElement) {
    return node.matches('meta[name="csrf-token]"');
  }
  return false;
}
// Up-to-date Cross-Site Request Forgery token
function csrfToken$1() {
  var _a;
  return (_a = getCookieValue(csrfParam$1())) !== null && _a !== void 0 ? _a : getMetaContent('csrf-token');
}
// URL param that must contain the CSRF token
function csrfParam$1() {
  return getMetaContent('csrf-param');
}
function CSRFProtection$1(request) {
  var token = csrfToken$1();
  var str = 'X-CSRF-TOKEN';
  if (token != null && request.headers.get(str) == null) request.headers.set('X-CSRF-TOKEN', token);
}

/**
 * Fetch Request is essentially an "proxy" class meant to wrap a standard Request
 *   Object and provide some sane convetions like passing in an abort controller,
 *   auto-serialization of FormData, auto-filling X-CSRF-Token and a number of other
 *   niceties. The FetchRequest constructor follows the same conventions as fetch.
 *   It can either take in a Request object, or be giving a url and then an object
 *   with all the fetch options.
 */
function FetchRequest$1(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var abortController = new AbortController();
  var abortSignal = abortController.signal;
  var headers;
  var url;
  var method = 'get';
  var request;
  var _isGetRequest = false;
  method = getMethod$1(options);
  _isGetRequest = isGetRequest(method);
  var body = getBody$2(options);
  if (input instanceof Request) {
    url = getUrl(input.url, _isGetRequest, body);
    request = createRequestFromRequest(input);
  } else {
    url = getUrl(input, _isGetRequest, body);
    request = createRequestFromLocateable();
  }
  if (!_isGetRequest) CSRFProtection$1(request);
  headers = request.headers;
  var params = url.searchParams;
  return {
    request: request,
    method: method,
    url: url,
    body: body,
    params: params,
    abortController: abortController,
    abortSignal: abortSignal,
    cancel: cancel,
    headers: headers,
    isGetRequest: _isGetRequest
  };
  function defaultHeaders() {
    var headers = new Headers({
      Accept: '*/*',
      'X-REQUESTED-WITH': 'XmlHttpRequest'
    });
    return headers;
  }
  function cancel(event) {
    abortController.abort();
    // trigger event dispatching if an event gets passed in.
    if (event != null) {
      stopEverything$1(event);
      var element = event.detail.element;
      dispatch.call(element, AJAX_EVENTS.ajaxStopped, {
        detail: _objectSpread({}, event.detail)
      });
    }
  }
  function createRequestFromRequest(input) {
    headers = mergeHeaders(defaultHeaders(), input.headers);
    var mergedOptions = _objectSpread(_objectSpread({}, defaultRequestOptions()), input);
    // @ts-expect-error
    if (_isGetRequest) delete mergedOptions.body;
    // @ts-expect-error this.url is really a URL, but typescript seems to think Request cant handle it.
    return new Request(url, mergedOptions);
  }
  function createRequestFromLocateable() {
    headers = mergeHeaders(defaultHeaders(), new Headers(options.headers));
    var mergedOptions = _objectSpread(_objectSpread({}, defaultRequestOptions()), options);
    mergedOptions.headers = headers;
    if (_isGetRequest) delete mergedOptions.body;
    // @ts-expect-error this.url is really a URL, but typescript seems to think Request cant handle it.
    return new Request(url, mergedOptions);
  }
  function defaultRequestOptions() {
    var options = {
      method: method,
      headers: headers,
      credentials: 'same-origin',
      redirect: 'follow',
      signal: abortSignal
    };
    if (_isGetRequest) {
      return options;
    }
    options.body = body;
    return options;
  }
}
function getUrl(url, getRequest, body) {
  var location = expandUrl(url);
  if (!getRequest) return location;
  // Append params to the Url.
  return mergeFormDataEntries(location, entries(body));
}
function entries(body) {
  return body instanceof URLSearchParams ? Array.from(body.entries()) : [];
}
function getBody$2(input) {
  var _a;
  return (_a = input.body) !== null && _a !== void 0 ? _a : new URLSearchParams();
}
function getMethod$1(input) {
  var _a, _b;
  return (_b = (_a = input.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : 'get';
}
function mergeFormDataEntries(url, entries) {
  var currentSearchParams = new URLSearchParams(url.search);
  var _iterator2 = _createForOfIteratorHelper(entries),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref5 = _step2.value;
      var _ref6 = _slicedToArray(_ref5, 2);
      var name = _ref6[0];
      var value = _ref6[1];
      if (value instanceof File) continue;
      // Only happens on GET requests, not needed.
      if (name === 'authenticity_token') continue;
      if (currentSearchParams.has(name)) {
        currentSearchParams.delete(name);
        url.searchParams.set(name, value);
      } else {
        url.searchParams.append(name, value);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return url;
}

/**
 * This handles FormSubmissions on forms that use data-remote="true"
 * This should not be interacted with directly and instead is merely meant for
 * connecting to the DOM.
 */
function FormSubmission(element, submitter) {
  var url = expandUrl(getAction(element, submitter));
  var options = getOptions(element, submitter);
  var fetchRequest = FetchRequest$1(url, options);
  var request = fetchRequest.request;
  return {
    fetchRequest: fetchRequest,
    request: request,
    element: element,
    submitter: submitter
  };
}
function getOptions(element, submitter) {
  var method = getMethod(element, submitter);
  var headers = getHeaders$1(element);
  var options = {
    method: method,
    headers: headers
  };
  // Will get stripped out by FetchRequest if its a GET request.
  options.body = getBody$1(element, method, submitter);
  return options;
}
/**
  * Headers to send to the request object
  */
function getHeaders$1(element) {
  var responseType;
  if (element != null) {
    responseType = element.dataset.type;
  }
  var acceptHeader = findResponseTypeHeader(responseType);
  var headers = new Headers({
    Accept: acceptHeader
  });
  headers.set('Accept', acceptHeader);
  return headers;
}
/**
  * Returns properly built FormData
  */
function getFormData$1(element, submitter) {
  return buildFormElementFormData(element, submitter);
}
/**
  * Finds how to send the fetch request
  * get, post, put, patch, etc
  */
function getMethod(element, submitter) {
  var _a, _b;
  var method = (_b = (_a = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute('formmethod')) !== null && _a !== void 0 ? _a : element.getAttribute('method')) !== null && _b !== void 0 ? _b : 'get';
  return method.toLowerCase();
}
function getAction(element, submitter) {
  var _a, _b;
  var action = (_b = (_a = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute('formaction')) !== null && _a !== void 0 ? _a : element.getAttribute('action')) !== null && _b !== void 0 ? _b : '';
  return action;
}
function getBody$1(element, method, submitter) {
  var formData = getFormData$1(element, submitter);
  if (getEncType(element, submitter) === FormEncTypes.urlEncoded || isGetRequest(method)) {
    return urlEncodeFormData(formData);
  } else {
    return formData;
  }
}
function getEncType(element, submitter) {
  var _a, _b;
  var elementEncType = element.getAttribute('enctype');
  var encType = (_b = (_a = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute('formenctype')) !== null && _a !== void 0 ? _a : elementEncType) !== null && _b !== void 0 ? _b : FormEncTypes.urlEncoded;
  var encString = formEnctypeFromString(encType);
  return encString;
}
function ElementDisabler() {
  var callbacks = [disableElement$1];
  var queries = [];
  function initialize() {
    queries = getQueries$5();
  }
  function connect() {
    addListeners(queries, callbacks);
  }
  function disconnect() {
    removeListeners(queries, callbacks);
  }
  function observerCallback(nodeList) {
    attachObserverCallback(queries, nodeList, callbacks);
  }
  return {
    name: 'ElementDisabler',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback,
    queries: queries
  };
}
function getQueries$5() {
  var _window$mrujs = window.mrujs,
    formSubmitSelector = _window$mrujs.formSubmitSelector,
    linkClickSelector = _window$mrujs.linkClickSelector,
    buttonClickSelector = _window$mrujs.buttonClickSelector,
    inputChangeSelector = _window$mrujs.inputChangeSelector;
  return [{
    event: 'click',
    selectors: [buttonClickSelector, linkClickSelector]
  }, {
    event: 'ajax:send',
    selectors: [formSubmitSelector]
  }, {
    event: 'turbo:submit-start',
    selectors: ['form']
  }, {
    event: 'change',
    selectors: [inputChangeSelector]
  }];
}
/**
  * Unified function to disable an element (link, button and form)
  */
function disableElement$1(event) {
  var element;
  if (event instanceof Event) {
    element = event.target;
  } else {
    element = event;
  }
  if (element == null) return;
  var _window$mrujs2 = window.mrujs,
    linkDisableSelector = _window$mrujs2.linkDisableSelector,
    buttonDisableSelector = _window$mrujs2.buttonDisableSelector,
    formDisableSelector = _window$mrujs2.formDisableSelector,
    formSubmitSelector = _window$mrujs2.formSubmitSelector;
  if (matches$1(element, linkDisableSelector)) {
    disableLinkElement(element);
  } else if (matches$1(element, buttonDisableSelector) || matches$1(element, formDisableSelector)) {
    disableFormElement(element);
  } else if (matches$1(element, formSubmitSelector)) {
    disableFormElements(element);
  }
}
/**
  * Disables form elements:
  *   - Caches element value in 'ujs-enable-with' data store
  *   - Replaces element text with value of 'data-disable-with' attribute
  *   - Sets disabled property to true
  */
function disableFormElements(form) {
  formElements$1(form, window.mrujs.formDisableSelector).forEach(function (el) {
    return disableFormElement(el);
  });
}
function disableFormElement(element) {
  if (element.dataset.ujsDisabled != null) return;
  var replacement = element.getAttribute('data-disable-with');
  if (replacement != null) {
    if (matches$1(element, 'button')) {
      element.dataset.ujsEnableWith = element.innerHTML;
      element.innerHTML = replacement;
    } else {
      element.dataset.ujsEnableWith = element.value;
      element.value = replacement;
    }
  }
  element.dataset.ujsDisabled = 'true';
  // Due to how FormSubmissions work in Chrome, if the button is disabled prior
  // to submitting the form, then form "submit" event will never trigger.
  setTimeout(function () {
    element.disabled = true;
  });
}
/**
  * Replace element's html with the 'data-disable-with' after storing original html
  *   and prevent clicking on it
  */
function disableLinkElement(element) {
  if (element.dataset.ujsDisabled != null) return;
  var replacement = element.dataset.disableWith;
  // Perhaps morph here instead??
  if (replacement != null) {
    element.dataset.ujsEnableWith = element.innerHTML;
    element.innerHTML = replacement;
  }
  element.addEventListener('click', stopEverything$1); // prevent further clicking
  element.dataset.ujsDisabled = 'true';
}
function FormSubmitDispatcher() {
  return {
    name: 'FormSubmitDispatcher',
    connect: connect$2,
    disconnect: disconnect$2
  };
}
function connect$2() {
  attachListeners('addEventListener');
}
function disconnect$2() {
  attachListeners('removeEventListener');
}
/**
  * Basic fetch request which leverages the FetchRequest object.
  *   This is an internal fetch
  *   Appropriate headers will be set for you but can be overriden.
  * @fires `ajax:before`
  */
function startFormSubmission(event) {
  if (event.defaultPrevented) {
    return;
  }
  // If it doesnt have remote="true"...forget about it!
  var element = findTarget(event);
  var submitter = findSubmitter(event);
  if (element.dataset.remote !== 'true') return;
  if (shouldNotSubmit(element)) return;
  if (shouldNotSubmit(submitter)) return;
  if (submitter != null) {
    disableElement$1(submitter);
  }
  event.preventDefault();
  var _FormSubmission = FormSubmission(element, submitter),
    fetchRequest = _FormSubmission.fetchRequest,
    request = _FormSubmission.request;
  var detail = {
    element: element,
    fetchRequest: fetchRequest,
    request: request,
    submitter: submitter
  };
  dispatch.call(element, AJAX_EVENTS.ajaxBefore, {
    detail: detail
  });
}
/**
  * Fires off a fetch request and returns the response data. Triggered by events.
  * @fires `ajax:beforeSend`
  * The request can be found via `event.detail.request`
  */
function startFetchRequest(event) {
  var _event$detail = event.detail,
    element = _event$detail.element,
    fetchRequest = _event$detail.fetchRequest,
    request = _event$detail.request,
    submitter = _event$detail.submitter;
  if (event.defaultPrevented || shouldNotSubmit(element) || shouldNotSubmit(submitter)) {
    dispatchStopped(event);
    return;
  }
  dispatch.call(element, AJAX_EVENTS.ajaxBeforeSend, {
    detail: {
      element: element,
      fetchRequest: fetchRequest,
      request: request,
      submitter: submitter
    }
  });
}
function sendFetchRequest(event) {
  var _event$detail2 = event.detail,
    element = _event$detail2.element,
    request = _event$detail2.request,
    submitter = _event$detail2.submitter;
  if (event.defaultPrevented || shouldNotSubmit(element) || shouldNotSubmit(submitter)) {
    dispatchStopped(event);
    return;
  }
  dispatch.call(element, AJAX_EVENTS.ajaxSend, {
    detail: _objectSpread({}, event.detail)
  });
  window.fetch(request).then(function (resp) {
    var fetchResponse = FetchResponse$1(resp);
    var response = fetchResponse.response;
    dispatchResponse(_objectSpread(_objectSpread({}, event.detail), {}, {
      fetchResponse: fetchResponse,
      response: response
    }));
  }).catch(function (error) {
    return dispatchRequestError(_objectSpread(_objectSpread({}, event.detail), {}, {
      error: error
    }));
  });
}
/**
  * Handles FetchResponses
  *   Fires `ajax:response:error` or `ajax:success` depending on the response.
  *   You can find the response in `event.detail.response`

/*
  * Dispatches the `ajax:complete` event.
  * { response, request?, error?, submitter } = detail
  */
function dispatchComplete(event) {
  if (event.defaultPrevented) {
    dispatchStopped(event);
    return;
  }
  dispatch.call(findTarget(event), AJAX_EVENTS.ajaxComplete, {
    detail: _objectSpread({}, event.detail)
  });
}
/**
  * Handles FetchResponses
  * @fires `ajax:response:error` or `ajax:success` depending on if the response succeeded.
  * properties: { request, response, submitter } = event.detail
  */
function dispatchResponse(_ref7) {
  var element = _ref7.element,
    fetchRequest = _ref7.fetchRequest,
    request = _ref7.request,
    fetchResponse = _ref7.fetchResponse,
    response = _ref7.response,
    submitter = _ref7.submitter;
  var status = response === null || response === void 0 ? void 0 : response.status;
  if ((fetchResponse === null || fetchResponse === void 0 ? void 0 : fetchResponse.succeeded) === true) {
    dispatch.call(element, AJAX_EVENTS.ajaxSuccess, {
      detail: {
        element: element,
        fetchRequest: fetchRequest,
        request: request,
        fetchResponse: fetchResponse,
        response: response,
        submitter: submitter,
        status: status
      }
    });
    return;
  }
  // Response errors, >= 400 responses
  dispatch.call(element, AJAX_EVENTS.ajaxResponseError, {
    detail: {
      element: element,
      fetchRequest: fetchRequest,
      request: request,
      fetchResponse: fetchResponse,
      response: response,
      submitter: submitter,
      status: status
    }
  });
}
/**
  * Handles a `fetch()` request error.
  * @fires `ajax:request:error`
  * properties: `{ request, error, submitter } = event.detail`
  */
function dispatchRequestError(_ref8) {
  var element = _ref8.element,
    fetchRequest = _ref8.fetchRequest,
    request = _ref8.request,
    error = _ref8.error,
    submitter = _ref8.submitter;
  dispatch.call(element, AJAX_EVENTS.ajaxRequestError, {
    detail: {
      element: element,
      fetchRequest: fetchRequest,
      request: request,
      error: error,
      submitter: submitter
    }
  });
}
/**
  * @fires the `ajax:error` event which is a catchall for request + response errors.
  * { response, request?, error?, submitter } = event.detail
  */
function dispatchError(event) {
  if (event.defaultPrevented) {
    dispatchStopped(event);
    return;
  }
  dispatch.call(findTarget(event), AJAX_EVENTS.ajaxError, {
    detail: _objectSpread({}, event.detail)
  });
}
// This is only for when event.defaultPrevented() is called.
// if a user calls `event.detail.submission.cancel()`, that will be triggered separately.
function dispatchStopped(event) {
  dispatch.call(findTarget(event), AJAX_EVENTS.ajaxStopped, {
    detail: _objectSpread({}, event.detail)
  });
}
/**
  * dispatches a given event in the context of `element`
  */
function attachListeners(fn) {
  document[fn]('submit', startFormSubmission); // fires ajaxBefore
  document[fn](AJAX_EVENTS.ajaxBefore, startFetchRequest); // fires ajaxBeforeSend
  // fires ajaxRequestError || ajaxSuccess || ajaxResponse
  document[fn](AJAX_EVENTS.ajaxBeforeSend, sendFetchRequest);
  document[fn](AJAX_EVENTS.ajaxSuccess, dispatchComplete);
  document[fn](AJAX_EVENTS.ajaxRequestError, dispatchError);
  document[fn](AJAX_EVENTS.ajaxResponseError, dispatchError);
  document[fn](AJAX_EVENTS.ajaxError, dispatchComplete);
}
function findTarget(event) {
  return event.target;
}
function shouldNotSubmit(element) {
  return (element === null || element === void 0 ? void 0 : element.dataset.ujsSubmit) === 'false';
}
function RemoteWatcher() {
  var query;
  function initialize() {
    query = window.mrujs.remoteSelector;
  }
  function connect() {
    $$1(query).forEach(function (el) {
      addTurboFalse(el);
    });
  }
  function disconnect() {}
  function observerCallback(nodeList) {
    nodeList.forEach(function (node) {
      if (matches$1(node, window.mrujs.remoteSelector)) {
        addTurboFalse(node);
      }
      if (node instanceof Element) {
        node.querySelectorAll(query).forEach(function (el) {
          addTurboFalse(el);
        });
      }
    });
  }
  return {
    name: 'RemoteWatcher',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback
  };
}
function addTurboFalse(el) {
  if (el == null) return;
  if (el.getAttribute('data-turbo') != null) return;
  el.setAttribute('data-turbo', 'false');
}
function ClickHandler() {
  var callbacks = [preventInsignificantClick$1];
  var queries = [];
  function initialize() {
    queries = getQueries$4();
  }
  function connect() {
    addListeners(queries, callbacks);
  }
  function disconnect() {
    removeListeners(queries, callbacks);
  }
  function observerCallback(nodeList) {
    attachObserverCallback(queries, nodeList, callbacks);
  }
  return {
    name: 'ClickHandler',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback,
    queries: queries,
    callbacks: callbacks
  };
}
function getQueries$4() {
  var _window$mrujs3 = window.mrujs,
    linkClickSelector = _window$mrujs3.linkClickSelector,
    buttonClickSelector = _window$mrujs3.buttonClickSelector,
    formInputClickSelector = _window$mrujs3.formInputClickSelector;
  return [{
    event: 'click',
    selectors: [linkClickSelector, buttonClickSelector, formInputClickSelector]
  }];
}
function Confirm() {
  var callbacks = [handleConfirm$1];
  var queries = [];
  function initialize() {
    queries = getQueries$3();
  }
  function connect() {
    addListeners(queries, callbacks);
  }
  function disconnect() {
    removeListeners(queries, callbacks);
  }
  function observerCallback(nodeList) {
    attachObserverCallback(queries, nodeList, callbacks);
  }
  return {
    name: 'Confirm',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback,
    queries: queries,
    callbacks: callbacks
  };
}
function handleConfirm$1(event) {
  if (!allowAction(event)) {
    stopEverything$1(event);
  }
}
function allowAction(event) {
  if (event.currentTarget == null) return true;
  var element = event.currentTarget;
  var message = element.dataset.confirm;
  if (message == null) return true;
  var answer = false;
  try {
    answer = window.mrujs.confirm(message);
  } catch (e) {
    console.warn('The following error was encountered when calling: "mrujs.confirm"\n\n');
    console.error(e);
  }
  var firedEvent = dispatch.call(element, 'confirm:complete', {
    detail: {
      answer: answer
    }
  });
  return answer && !firedEvent.defaultPrevented;
}
function getQueries$3() {
  var _window$mrujs4 = window.mrujs,
    linkClickSelector = _window$mrujs4.linkClickSelector,
    buttonClickSelector = _window$mrujs4.buttonClickSelector,
    formInputClickSelector = _window$mrujs4.formInputClickSelector,
    inputChangeSelector = _window$mrujs4.inputChangeSelector,
    formSubmitSelector = _window$mrujs4.formSubmitSelector;
  return [{
    event: 'click',
    selectors: [linkClickSelector, buttonClickSelector, formInputClickSelector]
  }, {
    event: 'change',
    selectors: [inputChangeSelector]
  }, {
    event: 'submit',
    selectors: [formSubmitSelector]
  }];
}

/**
 * This class handles data-method / data-remote submissions (<a data-remote"true">)
  */
function MethodSubmission(element) {
  var _a, _b;
  var method = getElementMethod(element);
  var maskedMethod;
  if ((_a = window.mrujs) === null || _a === void 0 ? void 0 : _a.maskLinkMethods) {
    maskedMethod = getMaskedMethod(method);
  }
  var href = (_b = element.getAttribute('href')) !== null && _b !== void 0 ? _b : element.dataset.url;
  if (href == null) {
    throw Error("No 'href' or 'data-url' found on ".concat(JSON.stringify(element)));
  }
  var url = expandUrl(href);
  var options = {
    headers: getHeaders(element)
  };
  options.method = maskedMethod !== null && maskedMethod !== void 0 ? maskedMethod : method;
  if (!isGetRequest(method)) options.body = getBody(method, element);
  var fetchRequest = FetchRequest$1(url, options);
  return {
    request: fetchRequest.request,
    fetchRequest: fetchRequest
  };
}
/**
 * Headers to send to the request object
 */
function getHeaders(element) {
  var responseType;
  if (element != null) {
    responseType = element.dataset.type;
  }
  var acceptHeader = findResponseTypeHeader(responseType);
  var headers = new Headers({
    Accept: acceptHeader
  });
  headers.set('Accept', acceptHeader);
  return headers;
}
/**
  * Returns properly built FormData
  */
function getFormData(method) {
  var _a;
  var formData = new FormData();
  if ((_a = window.mrujs) === null || _a === void 0 ? void 0 : _a.maskLinkMethods) {
    formData.append('_method', method);
  }
  return formData;
}
/**
  * Finds how to send the fetch request
  * get, post, put, patch, etc
  */
function getElementMethod(element) {
  // eslint-disable-next-line
  var method = element.dataset.method || 'get';
  return method.toLowerCase();
}
/**
  * If its a get request, leave it, everything else is masked as a POST.
  */
function getMaskedMethod(method) {
  return isGetRequest(method) ? 'get' : 'post';
}
function getBody(method, element) {
  var encodedFormData = urlEncodeFormData(getFormData(method));
  // add input's name and value to submission
  var elName = element.getAttribute('name');
  // cast to HTMLInputElement to make TS happy.
  var elValue = element.value;
  if (elName != null && elValue != null) encodedFormData.append(elName, elValue);
  var additionalParams = parseParams(element.getAttribute('data-params'));
  if (additionalParams == null) return encodedFormData;
  var _iterator3 = _createForOfIteratorHelper(additionalParams),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref9 = _step3.value;
      var _ref10 = _slicedToArray(_ref9, 2);
      var key = _ref10[0];
      var value = _ref10[1];
      if (value == null) continue;
      var val = value.toString();
      // Only strings can be added to UrlSearchParams
      var isString = typeof val === 'string' || val instanceof String;
      if (!isString) continue;
      encodedFormData.append(key, val.toString());
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return encodedFormData;
}
function parseParams(params) {
  if (params == null) return undefined;
  // convert encoded params to decoded params
  if (containsEncodedComponents(params)) {
    params = decodeURIComponent(params);
  }
  // json format
  try {
    return Object.entries(JSON.parse(params));
  } catch (_a) {}
  // param string format
  try {
    return new URLSearchParams(params).entries();
  } catch (_b) {}
  return undefined;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/decodeURIComponent
function containsEncodedComponents(x) {
  // ie ?,=,&,/ etc
  return decodeURI(x) !== decodeURIComponent(x);
}

/**
 * Handles `data-method="method"` submissions.
 */
function Method() {
  var callbacks = [handleMethod$1];
  var queries = [];
  function initialize() {
    queries = getQueries$2();
  }
  function connect() {
    addListeners(queries, callbacks);
  }
  function disconnect() {
    removeListeners(queries, callbacks);
  }
  function observerCallback(nodeList) {
    attachObserverCallback(queries, nodeList, callbacks);
  }
  return {
    name: 'Method',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback,
    queries: queries,
    callbacks: callbacks
  };
}
/**
  * Handles "data-method" on <a> tags such as:
  * @example
  *   // Not implemented!
  *   <a href="/users/5" data-method="delete" rel="nofollow" data-confirm="Are you sure?">Delete</a>
  *
  *   // Implemented!
  *   <a href="/users/5" data-method="delete" rel="nofollow">Delete</a>
  */
function handleMethod$1(event) {
  var _a;
  var element = event.currentTarget;
  // Make sure we dont fire on ctrl clicks.
  if (event instanceof MouseEvent && isInsignificantClick(event)) {
    return;
  }
  if (element.dataset.remote === 'false') return;
  if (element.dataset.method == null && element.dataset.remote !== 'true') return;
  // no href or url? Do not pass go.
  var href = (_a = element.getAttribute('href')) !== null && _a !== void 0 ? _a : element.dataset.url;
  if (href == null) return;
  event.preventDefault();
  var submitter = event.target;
  var linkSubmission = MethodSubmission(element);
  var fetchRequest = linkSubmission.fetchRequest,
    request = linkSubmission.request;
  /**
    * Send it through the event chain. use ajax:beforeSend because submit auto
    * populates fields that we dont want.
    */
  dispatch.call(element, AJAX_EVENTS.ajaxBeforeSend, {
    detail: {
      element: element,
      fetchRequest: fetchRequest,
      request: request,
      submitter: submitter
    }
  });
}
function getQueries$2() {
  var _window$mrujs5 = window.mrujs,
    linkClickSelector = _window$mrujs5.linkClickSelector,
    inputChangeSelector = _window$mrujs5.inputChangeSelector,
    buttonClickSelector = _window$mrujs5.buttonClickSelector;
  return [{
    event: 'click',
    selectors: [linkClickSelector, buttonClickSelector]
  }, {
    event: 'change',
    selectors: [inputChangeSelector]
  }];
}
var ALLOWABLE_ACTIONS = ['advance', 'replace', 'restore'];
function NavigationAdapter() {
  var obj = {
    name: 'NavigationAdapter',
    connect: connect$1,
    disconnect: disconnect$1,
    cacheContains: cacheContains,
    cacheHTML: cacheHTML,
    prefetch: prefetch,
    navigate: navigate
  };
  Object.defineProperties(obj, {
    adapter: {
      get: function get() {
        return findAdapter();
      }
    },
    snapshotCache: {
      get: function get() {
        return findSnapshotCache(findAdapter());
      }
    }
  });
  return obj;
}
function connect$1() {
  document.addEventListener('ajax:complete', beforeNavigation);
  document.addEventListener('ajax:beforeNavigation', navigateViaEvent);
}
function disconnect$1() {
  document.removeEventListener('ajax:complete', beforeNavigation);
  document.removeEventListener('ajax:beforeNavigation', navigateViaEvent);
}
function beforeNavigation(event) {
  if (event.defaultPrevented) return;
  dispatch.call(event.detail.element, 'ajax:beforeNavigation', {
    detail: _objectSpread({}, event.detail)
  });
}
function findAdapter() {
  if (useTurbolinks()) return window.Turbolinks;
  if (useTurbo()) return window.Turbo;
  return undefined;
}
function useTurbolinks() {
  if (window.Turbolinks == null) return false;
  if (window.Turbolinks.supported !== true) return false;
  return true;
}
function useTurbo() {
  if (window.Turbo == null) return false;
  return true;
}
/**
 * @example
 *   window.mrujs.prefetch("/blah") // This will automatically put a string or URL into the cache.
 */
function prefetch(_x) {
  return _prefetch.apply(this, arguments);
} // This used to be prefetch.
function _prefetch() {
  _prefetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(url) {
    var expandedUrl, response, fetchResponse, html;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          expandedUrl = expandUrl(url);
          _context4.next = 3;
          return window.mrujs.fetch(expandedUrl, {
            method: 'get'
          });
        case 3:
          response = _context4.sent;
          if (!(response == null)) {
            _context4.next = 6;
            break;
          }
          return _context4.abrupt("return");
        case 6:
          fetchResponse = FetchResponse$1(response);
          if (fetchResponse.isHtml) {
            _context4.next = 9;
            break;
          }
          return _context4.abrupt("return");
        case 9:
          _context4.next = 11;
          return fetchResponse.html();
        case 11:
          html = _context4.sent;
          cacheHTML({
            html: html,
            url: url
          });
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _prefetch.apply(this, arguments);
}
function cacheHTML(_ref11) {
  var html = _ref11.html,
    url = _ref11.url;
  var expandedUrl = expandUrl(url);
  var snapshot = generateSnapshotFromHtml(html);
  putSnapshotInCache(expandedUrl, snapshot);
}
function findSnapshotCache(adapter) {
  if (adapter == null) return undefined;
  if (useTurbolinks()) return adapter.controller.cache;
  if (useTurbo()) return adapter.navigator.view.snapshotCache;
  return undefined;
}
function cacheContains(url) {
  var _a;
  var expandedUrl = expandUrl(url);
  var snapshotCache = findSnapshotCache(findAdapter());
  return (_a = snapshotCache === null || snapshotCache === void 0 ? void 0 : snapshotCache.has(expandedUrl)) !== null && _a !== void 0 ? _a : false;
}
/**
  * Currently, this only fires on successful form submissions.
  */
function navigateViaEvent(event) {
  if (event.defaultPrevented) return;
  var _event$detail3 = event.detail,
    element = _event$detail3.element,
    fetchResponse = _event$detail3.fetchResponse,
    fetchRequest = _event$detail3.fetchRequest;
  if (!shouldNavigate(element, fetchResponse)) return;
  navigate(element, fetchRequest, fetchResponse);
}
function shouldNavigate(element, fetchResponse) {
  if (element.dataset.ujsNavigate === 'false') return false;
  if (fetchResponse == null) return false;
  // Only render / navigate responses on html responses.
  if (!fetchResponse.isHtml) return false;
  if (element instanceof HTMLFormElement && fetchResponse.succeeded && !fetchResponse.redirected) {
    console.error('Successful form submissions must redirect');
    return false;
  }
  return true;
}
/**
  * This is a manual navigation triggered by something like `method: :delete`
  */
function navigate(element, request, response, action) {
  // If we get redirected, use Turbolinks
  // This needs to be reworked to not trigger 2 HTML responses or find a
  // way to not refetch a page.
  action = action !== null && action !== void 0 ? action : determineAction(element);
  var location = expandUrl(window.location.href);
  if (request === null || request === void 0 ? void 0 : request.isGetRequest) location = request.url;
  if (response.redirected) location = response.location;
  var currentLocation = window.location.href;
  var isSamePage = urlsAreEqual(location, currentLocation);
  var errorRenderer = 'morphdom';
  if (window.mrujs.errorRenderer === 'turbo' || element.getAttribute('data-ujs-error-renderer') === 'turbo') {
    errorRenderer = 'turbo';
  }
  var shouldMorph = element.getAttribute('data-ujs-morph');
  var adapter = findAdapter();
  if (response.failed || isSamePage || adapter == null || shouldMorph === 'true') {
    // Use morphdom to dom diff the response if the response is HTML.
    morphResponse(element, response, !isSamePage, errorRenderer);
    return;
  }
  adapter.clearCache();
  // Special navigation handling for Turbo[links].
  preventDoubleVisit(response, location, action);
}
function putSnapshotInCache(location, snapshot) {
  if (snapshot === '') return;
  var snapshotCache = findSnapshotCache(findAdapter());
  snapshotCache === null || snapshotCache === void 0 ? void 0 : snapshotCache.put(expandUrl(location), snapshot);
}
function generateSnapshotFromHtml(html) {
  var _a, _b, _c;
  var adapter = findAdapter();
  if (adapter == null) return '';
  if (useTurbolinks()) {
    return (_a = adapter.Snapshot.wrap(html)) !== null && _a !== void 0 ? _a : '';
  }
  if (useTurbo() && canSnapshot()) {
    return (_c = (_b = adapter.PageSnapshot) === null || _b === void 0 ? void 0 : _b.fromHTMLString(html)) !== null && _c !== void 0 ? _c : '';
  }
  return '';
}
function canSnapshot() {
  var adapter = findAdapter();
  if (adapter == null) return false;
  if (useTurbolinks()) return true;
  if (useTurbo()) {
    // PageSnapshot is required in Turbo to manually generate Snapshots.
    if (adapter.PageSnapshot == null) {
      console.warn('The version of Turbo you are currently using does not support ' + 'snapshot generation. Please consider upgrading your version of Turbo.');
      return false;
    }
    return true;
  }
  return false;
}
function preventDoubleVisit(response, location, action) {
  var adapter = findAdapter();
  if (adapter == null) return;
  // This is a fun wrapper to avoid double visits with Turbolinks
  response.html().then(function (html) {
    cacheHTML({
      html: html,
      url: location
    });
    action = 'restore';
    adapter.visit(location, {
      action: action
    });
  }).catch(function (error) {
    return console.error(error);
  });
}
function morphResponse(element, response) {
  var pushState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var errorRenderer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'morphdom';
  // Dont pass go if its not HTML.
  if (!response.isHtml) return;
  response.html().then(function (html) {
    var _a;
    if (errorRenderer === 'turbo') {
      renderError(html);
    } else if (errorRenderer === 'morphdom') {
      var selectorString = element.getAttribute('data-ujs-morph-root');
      var selector = document.documentElement;
      if (selectorString != null) {
        if (selectorString.trim() === '') {
          selector = element;
        } else {
          selector = (_a = document.querySelector(selectorString)) !== null && _a !== void 0 ? _a : document.documentElement;
        }
      }
      morphHtml(html, selector);
    }
    if (pushState) {
      // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
      window.history.pushState({}, '', response.location);
    }
  }).catch(function (error) {
    console.error(error);
  });
}
function morphHtml(html) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
  var template = document.createElement('template');
  template.innerHTML = String(html).trim();
  var content = selector === document.documentElement ? template.innerHTML : template.content;
  document.dispatchEvent(new CustomEvent('ujs:beforeMorph'));
  morphdom(selector, content, {
    childrenOnly: true
  });
  document.dispatchEvent(new CustomEvent('ujs:afterMorph'));
}
function renderError(html) {
  var adapter = findAdapter();
  adapter === null || adapter === void 0 ? void 0 : adapter.navigator.view.renderError(generateSnapshotFromHtml(html));
}
function determineAction(element) {
  var _a, _b;
  var action = (_b = (_a = element.dataset.turbolinksAction) !== null && _a !== void 0 ? _a : element.dataset.turboAction) !== null && _b !== void 0 ? _b : 'advance';
  if (!ALLOWABLE_ACTIONS.includes(action)) {
    action = 'advance';
  }
  return action;
}
function DisabledElementChecker() {
  var callbacks = [handleDisabledElement$1];
  var queries = [];
  function initialize() {
    queries = getQueries$1();
  }
  function connect() {
    addListeners(queries, callbacks);
  }
  function disconnect() {
    removeListeners(queries, callbacks);
  }
  function observerCallback(nodeList) {
    attachObserverCallback(queries, nodeList, callbacks);
  }
  return {
    name: 'DisabledElementChecker',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback,
    queries: queries,
    callbacks: callbacks
  };
}
function getQueries$1() {
  var _window$mrujs6 = window.mrujs,
    linkClickSelector = _window$mrujs6.linkClickSelector,
    buttonClickSelector = _window$mrujs6.buttonClickSelector,
    inputChangeSelector = _window$mrujs6.inputChangeSelector,
    formSubmitSelector = _window$mrujs6.formSubmitSelector,
    formInputClickSelector = _window$mrujs6.formInputClickSelector;
  return [{
    event: 'click',
    selectors: [buttonClickSelector, linkClickSelector, formInputClickSelector]
  }, {
    event: 'change',
    selectors: [inputChangeSelector]
  }, {
    event: 'submit',
    selectors: [formSubmitSelector]
  }];
}
function handleDisabledElement$1(event) {
  if (this.disabled === true) stopEverything$1(event);
}
function ElementEnabler() {
  var callbacks = [enableElement$1];
  var queries = [];
  function initialize() {
    queries = getQueries();
  }
  function connect() {
    addListeners(queries, callbacks);
  }
  function disconnect() {
    removeListeners(queries, callbacks);
  }
  function observerCallback(nodeList) {
    attachObserverCallback(queries, nodeList, callbacks);
  }
  return {
    name: 'ElementEnabler',
    initialize: initialize,
    connect: connect,
    disconnect: disconnect,
    observerCallback: observerCallback,
    callbacks: callbacks
  };
}
function getQueries() {
  var _window$mrujs7 = window.mrujs,
    formSubmitSelector = _window$mrujs7.formSubmitSelector,
    buttonDisableSelector = _window$mrujs7.buttonDisableSelector,
    linkDisableSelector = _window$mrujs7.linkDisableSelector,
    inputChangeSelector = _window$mrujs7.inputChangeSelector;
  var selectors = [linkDisableSelector, buttonDisableSelector, formSubmitSelector, inputChangeSelector];
  return [{
    event: AJAX_EVENTS.ajaxComplete,
    selectors: selectors
  }, {
    event: AJAX_EVENTS.ajaxStopped,
    selectors: selectors
  }, {
    event: 'turbo:submit-end',
    selectors: selectors
  }];
}
// Unified function to enable an element (link, button and form)
function enableElement$1(trigger) {
  var element = trigger;
  if (trigger instanceof Event) element = trigger.target;
  var _window$mrujs8 = window.mrujs,
    linkDisableSelector = _window$mrujs8.linkDisableSelector,
    buttonDisableSelector = _window$mrujs8.buttonDisableSelector,
    formEnableSelector = _window$mrujs8.formEnableSelector,
    formSubmitSelector = _window$mrujs8.formSubmitSelector;
  if (matches$1(element, linkDisableSelector)) {
    enableLinkElement(element);
    return;
  }
  if (matches$1(element, buttonDisableSelector) || matches$1(element, formEnableSelector)) {
    enableFormElement(element);
    return;
  }
  if (matches$1(element, formSubmitSelector)) {
    enableFormElements(element);
  }
}
/**
  * Restore element to its original state which was disabled by 'disableLinkElement' above
  */
function enableLinkElement(element) {
  var originalText = element.dataset.ujsEnableWith;
  if (originalText != null) {
    element.innerHTML = originalText; // set to old enabled state
    element.removeAttribute('data-ujs-enable-with'); // clean up cache
  }

  element.removeEventListener('click', stopEverything$1); // enable element
  element.removeAttribute('data-ujs-disabled');
}
/**
 * Re-enables disabled form elements:
 *  - Replaces element text with cached value from 'ujs-enable-with' data store (created in `disableFormElements`)
 *  - Sets disabled property to false
 */
function enableFormElements(form) {
  var elements = formElements$1(form, window.mrujs.formEnableSelector);
  elements.forEach(enableFormElement);
}
function enableFormElement(element) {
  var originalText = element.dataset.ujsEnableWith;
  if (originalText != null) {
    if (matches$1(element, 'button')) {
      element.innerHTML = originalText;
    } else {
      element.value = originalText;
    }
    element.removeAttribute('data-ujs-enable-with'); // clean up cache
  }

  element.disabled = false;
  element.removeAttribute('data-ujs-disabled');
}

/**
 * Mutation observer for added nodes.
 */
function AddedNodesObserver(callback) {
  var observer = new MutationObserver(callback);
  function connect() {
    observer.observe(document, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }
  function disconnect() {
    observer.disconnect();
  }
  return {
    name: 'AddedNodesObserver',
    connect: connect,
    disconnect: disconnect
  };
}
function Mrujs() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  obj.connected = false;
  obj = _objectSpread({}, BASE_SELECTORS);
  obj.FetchResponse = FetchResponse$1;
  obj.FetchRequest = FetchRequest$1;
  obj.addedNodesObserver = AddedNodesObserver(addedNodesCallback);
  obj.remoteWatcher = RemoteWatcher();
  obj.elementEnabler = ElementEnabler();
  obj.elementDisabler = ElementDisabler();
  obj.disabledElementChecker = DisabledElementChecker();
  obj.navigationAdapter = NavigationAdapter();
  obj.clickHandler = ClickHandler();
  obj.confirmClass = Confirm();
  obj.csrf = Csrf();
  obj.method = Method();
  obj.formSubmitDispatcher = FormSubmitDispatcher();
  // Order matters here!
  var corePlugins = [obj.addedNodesObserver, obj.remoteWatcher, obj.csrf, obj.elementEnabler, obj.clickHandler, obj.disabledElementChecker, obj.confirmClass, obj.elementDisabler, obj.method, obj.formSubmitDispatcher, obj.navigationAdapter];
  obj.corePlugins = corePlugins;
  var plugins = (_a = obj.plugins) !== null && _a !== void 0 ? _a : [];
  obj.plugins = plugins;
  var allPlugins = corePlugins.concat(plugins);
  obj.allPlugins = allPlugins;
  obj.maskLinkMethods = true;
  obj.mimeTypes = _objectSpread({}, BASE_ACCEPT_HEADERS);
  obj.stop = stop;
  obj.restart = restart;
  obj.fetch = fetch;
  obj.urlEncodeFormData = urlEncodeFormData;
  obj.registerMimeTypes = registerMimeTypes;
  obj.enableElement = enableElement$1;
  obj.enableFormElements = enableFormElements;
  obj.enableFormElement = enableFormElement;
  obj.disableElement = disableElement$1;
  obj.stopEverything = stopEverything$1;
  obj.dispatch = dispatch;
  obj.addListeners = addListeners;
  obj.removeListeners = removeListeners;
  obj.attachObserverCallback = attachObserverCallback;
  obj.expandUrl = expandUrl;
  obj.findSubmitter = findSubmitter;
  // a wrapper for document.querySelectorAll
  obj.$ = $$1;
  obj.CSRFProtection = CSRFProtection$1;
  obj.csrfParam = csrfParam$1;
  obj.csrfToken = csrfToken$1;
  obj.cspNonce = cspNonce$1;
  obj.confirm = confirm$1;
  obj.handleConfirm = handleConfirm$1;
  obj.handleDisabledElement = handleDisabledElement$1;
  obj.handleMethod = handleMethod$1;
  obj.start = start$1;
  obj.preventInsignificantClick = preventInsignificantClick$1;
  obj.refreshCSRFTokens = refreshCSRFTokens$1;
  obj.delegate = delegate$1;
  obj.fire = fire$1;
  obj.formElements = formElements$1;
  obj.matches = matches$1;
  obj.toArray = toArray;
  obj.prefetch = obj.navigationAdapter.prefetch;
  return obj;
}
function start$1() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  window.Rails = window.mrujs = this;
  // Dont start twice!
  if (window.mrujs.connected) {
    return window.mrujs;
  }
  Object.assign(this, options);
  this.allPlugins = this.corePlugins.concat(this.plugins);
  for (var i = 0; i < this.allPlugins.length; i++) {
    var plugin = this.allPlugins[i];
    (_a = plugin.initialize) === null || _a === void 0 ? void 0 : _a.call(plugin);
  }
  connect();
  return this;
}
function stop() {
  disconnect();
}
function restart() {
  disconnect();
  connect();
}
function connect() {
  var _a;
  // This event works the same as the load event, except that it fires every
  // time the page is loaded.
  // See https://github.com/rails/jquery-ujs/issues/357
  // See https://developer.mozilla.org/en-US/docs/Using_Firefox_1.5_caching
  reEnableDisabledElements();
  window.addEventListener('pageshow', reEnableDisabledElements);
  for (var i = 0; i < window.mrujs.allPlugins.length; i++) {
    var plugin = window.mrujs.allPlugins[i];
    (_a = plugin.connect) === null || _a === void 0 ? void 0 : _a.call(plugin);
  }
  window.mrujs.connected = true;
}
function disconnect() {
  var _a;
  window.removeEventListener('pageshow', reEnableDisabledElements);
  for (var i = 0; i < window.mrujs.allPlugins.length; i++) {
    var plugin = window.mrujs.allPlugins[i];
    (_a = plugin.disconnect) === null || _a === void 0 ? void 0 : _a.call(plugin);
  }
  window.mrujs.connected = false;
}
function confirm$1(message) {
  return window.confirm(message);
}
function addedNodesCallback(mutationList, _observer) {
  var _iterator4 = _createForOfIteratorHelper(mutationList),
    _step4;
  try {
    var _loop = function _loop() {
      var mutation = _step4.value;
      var addedNodes;
      if (mutation.type === 'attributes') {
        addedNodes = [mutation.target];
      } else {
        addedNodes = Array.from(mutation.addedNodes);
      }
      // kick it into setTimeout so we dont delay rendering
      window.setTimeout(function () {
        var _a;
        for (var i = 0; i < window.mrujs.allPlugins.length; i++) {
          var plugin = window.mrujs.allPlugins[i];
          (_a = plugin.observerCallback) === null || _a === void 0 ? void 0 : _a.call(plugin, addedNodes);
        }
      }, 0);
    };
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
function fetch(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = options.element,
    submitter = options.submitter,
    dispatchEvents = options.dispatchEvents;
  delete options.element;
  delete options.submitter;
  delete options.dispatchEvents;
  var fetchRequest = FetchRequest$1(input, options);
  if (dispatchEvents === true) {
    if (element == null) element = document.documentElement;
    dispatch.call(element, AJAX_EVENTS.ajaxBeforeSend, {
      detail: {
        element: element,
        fetchRequest: fetchRequest,
        request: fetchRequest.request,
        submitter: submitter
      }
    });
    return undefined;
  }
  return window.fetch(fetchRequest.request);
}
function registerMimeTypes(mimeTypes) {
  mimeTypes.forEach(function (mimeType) {
    var shortcut = mimeType.shortcut,
      header = mimeType.header;
    window.mrujs.mimeTypes[shortcut] = header;
  });
  return window.mrujs.mimeTypes;
}
function reEnableDisabledElements() {
  var _window$mrujs9 = window.mrujs,
    formEnableSelector = _window$mrujs9.formEnableSelector,
    linkDisableSelector = _window$mrujs9.linkDisableSelector;
  $$1("".concat(formEnableSelector, ", ").concat(linkDisableSelector)).forEach(function (element) {
    var el = element;
    // Reenable any elements previously disabled
    enableElement$1(el);
  });
}
function cspNonce$1() {
  return getMetaContent('csp-nonce');
}

// Currently only import the safari submit event polyfill.
var mrujs = Mrujs();
// Yay...esmodules!
var $ = mrujs.$,
  CSRFProtection = mrujs.CSRFProtection,
  buttonClickSelector = mrujs.buttonClickSelector,
  buttonDisableSelector = mrujs.buttonDisableSelector,
  cspNonce = mrujs.cspNonce,
  csrfParam = mrujs.csrfParam,
  csrfToken = mrujs.csrfToken,
  confirm = mrujs.confirm,
  delegate = mrujs.delegate,
  disableElement = mrujs.disableElement,
  enableElement = mrujs.enableElement,
  fileInputSelector = mrujs.fileInputSelector,
  fire = mrujs.fire,
  formDisableSelector = mrujs.formDisableSelector,
  formElements = mrujs.formElements,
  formEnableSelector = mrujs.formEnableSelector,
  formInputClickSelector = mrujs.formInputClickSelector,
  formSubmitSelector = mrujs.formSubmitSelector,
  handleConfirm = mrujs.handleConfirm,
  handleDisabledElement = mrujs.handleDisabledElement,
  handleMethod = mrujs.handleMethod,
  inputChangeSelector = mrujs.inputChangeSelector,
  linkClickSelector = mrujs.linkClickSelector,
  linkDisableSelector = mrujs.linkDisableSelector,
  matches = mrujs.matches,
  preventInsignificantClick = mrujs.preventInsignificantClick,
  refreshCSRFTokens = mrujs.refreshCSRFTokens,
  start = mrujs.start,
  stopEverything = mrujs.stopEverything,
  FetchResponse = mrujs.FetchResponse,
  FetchRequest = mrujs.FetchRequest;
export { $, CSRFProtection, FetchRequest, FetchResponse, Mrujs, buttonClickSelector, buttonDisableSelector, confirm, cspNonce, csrfParam, csrfToken, mrujs as default, delegate, disableElement, enableElement, fileInputSelector, fire, formDisableSelector, formElements, formEnableSelector, formInputClickSelector, formSubmitSelector, handleConfirm, handleDisabledElement, handleMethod, inputChangeSelector, linkClickSelector, linkDisableSelector, matches, mrujs, preventInsignificantClick, refreshCSRFTokens, start, stopEverything };